import React, { createContext, useContext, useRef, useCallback } from 'react';

const Tom2LockContext = createContext(null);

export function Tom2LockProvider({ children }) {
  const isLockedRef = useRef(false);

  const lockTom2 = useCallback(() => {
    isLockedRef.current = true;
  }, []);

  const unlockTom2 = useCallback(() => {
    isLockedRef.current = false;
  }, []);

  const isTom2Locked = useCallback(() => {
    return isLockedRef.current;
  }, []);

  return (
    <Tom2LockContext.Provider value={{ lockTom2, unlockTom2, isTom2Locked }}>
      {children}
    </Tom2LockContext.Provider>
  );
}

export function useTom2Lock() {
  return useContext(Tom2LockContext);
}
